import ImageContainer from "./Upload";
const Image = ImageContainer;
export default Image 